import React from 'react';
import { Box, List, ListItem, ListItemIcon, ListItemText, Hidden,useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const SideNav = ({ sideNavItems }) => {
  const theme = useTheme();

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('xs')); // Check if screen is extra-small
  if (isSmallScreen) {
    return null; // Don't render on extra-small screens
  }
  return (
      <Box
        sx={{
          width: { sm: 240 }, // Width changes based on screen size
          height: '100%', // Full viewport height
          borderRadius: { xs: '20px', sm: '20px' }, // Rounded corners
          backgroundColor: '#F5F5F5', // Light gray background
          boxShadow: '2px 0px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
          padding: 1, // Inner padding
          display: { xs: 'none', sm: 'flex' },           flexDirection: 'column',
          margin: 3,
          top: 0,
          left: 0,
        }}
      >
        <List sx={{ padding: 0 }}>
          {sideNavItems.map((item, index) => (
            <ListItem
              button
              key={index}
              sx={{
                margin: 1,
                borderRadius: '12px', // Rounded list items
                '&:hover': {
                  backgroundColor: '#E0E0E0', // Hover effect
                },
                display: 'flex',
                justifyContent: { xs: 'center', sm: 'flex-start' },
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: '40px',
                  justifyContent: 'center',
                  color: '#555',
                }}
              >
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={item.text}
                sx={{
                  // Add text styling if necessary
                }}
              >
                {item.text}
              </ListItemText>
            </ListItem>
          ))}
        </List>
      </Box>
  );
};

export default SideNav;
